export enum DistanceUnit {
  KILOMETERS = "KILOMETERS",
  MILES = "MILES",
}

export interface Distance {
  value: number;
  unit: DistanceUnit;
}
